import { render, staticRenderFns } from "./penerimaanFppkEdit.vue?vue&type=template&id=4a561862&scoped=true"
import script from "./penerimaanFppkEdit.vue?vue&type=script&lang=js"
export * from "./penerimaanFppkEdit.vue?vue&type=script&lang=js"
import style0 from "./penerimaanFppkEdit.vue?vue&type=style&index=0&id=4a561862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a561862",
  null
  
)

export default component.exports